// This module provides API call methods for Sephora Commerce
// Search & Browse APIs:
// https://jira.sephora.com/wiki/pages/viewpage.action?pageId=120041949

const getProductDetails = require('./getProductDetails');
const getSkuDetails = require('./getSkuDetails');
const findInStore = require('./findInStore');
const searchProductsByKeyword = require('./searchProductsByKeyword');
const searchTypeAhead = require('./searchTypeAhead');
const getCategories = require('./getCategories');
const getSpecialSearchTermComponents = require('./getSpecialSearchTermComponents');
const {
    getNthLevelCategory,
    getCategory
} = require('./getNthLevelCategory');
const {
    getNthLevelBrand,
    getBrand
} = require('./getNthLevelBrand');

module.exports = {
    getProductDetails,
    getSkuDetails,
    findInStore,
    searchProductsByKeyword,
    searchTypeAhead,
    getNthLevelCategory,
    getCategory,
    getCategories,
    getNthLevelBrand,
    getBrand,
    getSpecialSearchTermComponents
};
